module.exports = new __parcel__URL__("projects-files-darkmode.0f2948c3.svg").toString();